import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ChatNewsletterEntityService {
  private entitiyNameSubject = new BehaviorSubject<string>('');

  entitiyName$ = this.entitiyNameSubject.asObservable();

  get getEntitiyName(): string {
    return this.entitiyNameSubject.value;
  }

  setEntityName(name: string): void {
    this.entitiyNameSubject.next(name);
  }
}
